export default __webpack_public_path__ + "static/media/caret-down.caa4057c.svg";